<template>
  <sTooltip
    :border="false"
    placement="bottom"
    :popper-class="`${contentClass} info-tooltip`"
    :type="error ? 'error' : typeTooltip">
    <div>
      <sIcon
        class="ml-1"
        :color="error ? 'var(--color-error)' : color"
        height="14"
        :type="icon"/>
    </div>
    <template #content>
      <span
        v-dompurify-html="content"
        class="h8-text"/>
    </template>
  </sTooltip>
</template>
<script>
export default {
  name: 'infoIconWithTooltip',
  props: {
    color: String,
    content: String,
    contentClass: {
      type: String,
      default: ''
    },
    error: Boolean,
    typeTooltip: {
      type: String,
      default: 'white'
    },
    icon: {
      type: String,
      default: 'info'
    }
  }
}
</script>
<style lang="scss">
.info-tooltip {
  max-width: 300px;
}
</style>
